const baseUrl = "/api/bettermode";

/**
 * GET Requests
 */

const bettermodeGet = async (resourceIdentifier) => {
  try {
    const getResponse = await fetch(`${baseUrl}/${resourceIdentifier}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "include"
    });

    if (!getResponse.ok) {
      const err = await handleErrorResponse(getResponse); // Handle Error and Parse Response
      throw err;
    }

    return getResponse;
  } catch (error) {
    console.error(`Error in get request [${resourceIdentifier}]:`, error);
    throw error;
  }
};

export async function findAccountWithoutHandshake({
  email = "",
  lastName = "",
  firstName = "",
  regtype = ""
}) {
  try {
    const url = `find-account?email=${email}&lastname=${lastName}&firstname=${firstName}&regtype=${regtype}`;
    const resp = await bettermodeGet(url);
    const respJson = await resp.json();

    return handleResponse(respJson);
  } catch (err) {
    return Promise.reject(err);
  }
}

/**
 * POST Requests
 */

const bettermodePost = async (resourceIdentifier, data) => {
  try {
    const postResponse = await fetch(`${baseUrl}/${resourceIdentifier}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data),
      credentials: "include"
    });

    if (!postResponse.ok) {
      const err = await handleErrorResponse(postResponse); // Handle Error and Parse Response
      throw err;
    }

    return postResponse;
  } catch (error) {
    console.error(`Error in post request [${resourceIdentifier}]:`, error);
    throw error;
  }
};

export async function registrationRequest(formData) {
  try {
    const resp = await bettermodePost("register-user", formData);
    const respJson = await resp.json();

    return handleResponse(respJson);
  } catch (err) {
    return Promise.reject(err);
  }
}

export async function sendAuthLink(userEmail) {
  try {
    const resp = await bettermodePost("send-auth-link", { email: userEmail });
    const respJson = await resp.json();

    return handleResponse(respJson);
  } catch (err) {
    return Promise.reject(err);
  }
}

export async function sendInterestEmail(data) {
  try {
    const resp = await bettermodePost("contact-not-found", data);
    const respJson = await resp.json();

    return handleResponse(respJson);
  } catch (err) {
    return Promise.reject(err);
  }
}

/**
 * Utilities
 */

export function parseJson(json) {
  try {
    return JSON.parse(json);
  } catch (err) {
    return null;
  }
}

export function parseJsonError(json, defaultErrorMessage = "Error response") {
  const parsedJson = parseJson(json);

  if (parsedJson && parseJson.message) {
    const err = new Error(parsedJson.message);
    return err;
  }

  return defaultErrorMessage;
}

export async function handleErrorResponse(resp) {
  const parsedMessage = await resp.text().catch(() => "error occurred");
  const err = new Error(parsedMessage);
  err.resp = resp;
  return err;
}

export function handleResponse(respJson) {
  if (!respJson.success) {
    const errorMessage = parseJsonError(respJson);
    const err = new Error(errorMessage);
    err.resp = respJson;
    throw err;
  }

  return respJson;
}
